import { render, staticRenderFns } from "./main-attorneys.vue?vue&type=template&id=f9e6e1b0&scoped=true"
import script from "./main-attorneys.vue?vue&type=script&lang=js"
export * from "./main-attorneys.vue?vue&type=script&lang=js"
import style0 from "./main-attorneys.vue?vue&type=style&index=0&id=f9e6e1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e6e1b0",
  null
  
)

export default component.exports